import { useTheme } from '@mui/material';

import {
  CartesianGrid,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
  Line,
  Legend,
} from 'recharts';

const OverviewChart = ({ dataSets }) => {
  const theme = useTheme();
  return (
    <>
      {dataSets?.length && (
        <LineChart
          width={700}
          height={400}
          data={dataSets}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' />
          <YAxis />
          <Tooltip />
          <Legend verticalAlign='top' height={36} />
          <Line
            type='monotone'
            dataKey='count'
            stroke={theme.palette.primary.main}
          />
        </LineChart>
      )}
    </>
  );
};

export default OverviewChart;
